import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPage() {
    const { t } = useTranslation();
    const sections = t("privacy.sections", { returnObjects: true });
    return (
        <section className="aurx-legal" data-testid="privacy-page">
            <div className="aurx-container aurx-legal-body">
                <span className="aurx-updated">{t("privacy.updated")}</span>
                <h1
                    className="aurx-h2"
                    style={{ marginTop: 12, marginBottom: 20 }}
                >
                    {t("privacy.title")}
                </h1>
                <p className="p-lead">{t("privacy.intro")}</p>
                {Object.keys(sections).map((k) => (
                    <div key={k}>
                        <h2>{sections[k].title}</h2>
                        <p>{sections[k].body}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
